import { useContext, useRef, useState } from "react";
import Slider from "react-slick";
import { AppContext } from "../App";
import supplyImage from "../assets/children_clothing.jpg";
import residentialImage from "../assets/home_furniture2.jpg";
import deepCleaningImage from "../assets/polishing.jpg";
import bigLogo from "../assets/big_logo.png";

const slides = [
  {
    image: supplyImage,
    title: "Importation and Supply of goods",
    text: "We import and supply children products and wear, clothing, kitchen materials, furnitures and other consumable materials",
    buttonLabel: "Explore Supplies",
    action: "services",
  },
  {
    image: residentialImage,
    title: "Residential Cleaning",
    text: "We provide residential cleaning services including areas like bathrooms, living rooms, kitchens and countertops",
    buttonLabel: "Book Residential Cleaning",
    action: "contact_us",
  },
  {
    image: deepCleaningImage,
    title: "Deep Cleaning",
    text: "Deep cleaning includes handwashing cabinets, vacuuming upholstery, polishing wood, and cleaning the oven, ceiling fan blades, baseboards, and more",
    buttonLabel: "Request Deep Cleaning",
    action: "contact_us",
  },
];

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const sliderRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5200,
    speed: 1100,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    beforeChange: (_, next) => setActiveSlide(next),
  };

  return (
    <section className="hero-banner">
      <Slider ref={sliderRef} {...settings} className="hero-banner-slider">
        {slides.map((slide, index) => (
          <div key={slide.title}>
            <div
              className={`hero-slide${index === activeSlide ? " active" : ""}`}
              style={{
                backgroundImage: `url(${slide.image})`,
              }}
            >
              <div className="container hero-banner-content">
                <div className="hero-copy-shell" data-aos="fade-up" data-aos-delay={120 + index * 60}>
                  <div className="hero-brand-mark">
                    <img src={bigLogo} alt="MS Universal Distributors logo" />
                  </div>

                  <div className="hero-copy">
                    <h1>{slide.title}</h1>
                    <p>{slide.text}</p>

                    <div className="hero-actions">
                      <button
                        className="btn btn-primary hero-single-btn"
                        onClick={() => appContext.navTo({ item: slide.action })}
                      >
                        {slide.buttonLabel}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <div className="vex-hero-dots" role="tablist" aria-label="Slide navigation">
        {slides.map((_, i) => (
          <button
            key={i}
            role="tab"
            aria-selected={i === activeSlide}
            aria-label={`Go to slide ${i + 1}`}
            className={`vex-hero-dot${i === activeSlide ? " active" : ""}`}
            onClick={() => sliderRef.current?.slickGoTo(i)}
          />
        ))}
      </div>
    </section>
  );
}
